import { render } from "./AddInventoryWizard.vue?vue&type=template&id=7a245868&scoped=true"
import script from "./AddInventoryWizard.vue?vue&type=script&lang=js"
export * from "./AddInventoryWizard.vue?vue&type=script&lang=js"

import "./AddInventoryWizard.vue?vue&type=style&index=0&id=7a245868&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a245868"]])

export default __exports__